<template>
  <v-app-bar
    v-if="!shouldHideAppBar"
    app
    :class="{
      'dark-gradient': themeStore.isDarkMode,
      'light-gradient': !themeStore.isDarkMode && !isQumowillUser,
      'qumowill-gradient': !themeStore.isDarkMode && isQumowillUser,
      'no-shadow': true,
      'dark-text': themeStore.isDarkMode,
      'light-text': !themeStore.isDarkMode,
      'd-flex': true,
      'align-center': true,
    }"
    :dark="themeStore.isDarkMode"
    :style="appBarStyle"
    height="64"
    :scroll-behavior="themeStore.isMobile ? 'hide' : undefined"
  >
    <v-app-bar-title>
      <router-link
        :to="authStore.homePath"
        class="d-flex align-center"
        @click="roomStore.closeRoomDetail"
        style="text-decoration: none; color: inherit"
      >
        <img
          v-if="isTaitockUser"
          :src="taitockLogoSrc"
          alt="TaiTock Logo"
          class="logo logo-taitock"
        />
        <img
          v-else-if="isQumowillUser"
          :src="qumowillLogoSrc"
          alt="Qumowill AI Logo"
          class="logo"
        />
        <img
          v-else
          src="/Poranos_logo.png"
          alt="Poranos Logo"
          class="logo"
        />
      </router-link>
    </v-app-bar-title>
    <v-spacer></v-spacer>

    <!-- <span
      v-if="linkStore.isUserLinking"
      class="mr-2"
      style="font-weight: bold; color: #4caf50"
    >
      ペアリング中
    </span> -->
    <v-btn
      v-if="linkStore.isUserLinking"
      class="mr-2"
      color="success"
      variant="tonal"
      @click="goToOperation"
    >
      ペアリング中
    </v-btn>
    <span
      v-else-if="linkStore.isRoomLinking"
      class="mr-2"
      style="font-weight: bold; color: #4caf50"
    >
      リンク中
    </span>
    <!-- ✅ ゲストではない場合にユーザー名を表示 -->
    <!-- ✅ displayName がある場合に表示 -->
    <span
      v-if="!isGuest"
      class="mr-3 user-name clickable"
      @click="showEditNameModal = true"
    >
      {{ shownName }}
    </span>
    <!-- ✨ 編集用モーダル -->
    <EditDisplayNameModal
      v-model="showEditNameModal"
      :currentName="displayName"
    />
    <!-- ✅ ゲストの場合に「ログイン」ボタンを表示 -->
    <v-btn v-if="isGuest" class="mr-3" color="primary" @click="openModal">
      ログイン
    </v-btn>

    <!-- ✅ ユーザー名を表示 -->

    <!-- ドロップダウンメニュー -->
    <v-menu offset-y attach="body">
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="!authStore.isGuest">
          <v-btn variant="text" class="text-left px-4" @click="logout">
            ログアウト
          </v-btn>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <v-switch
              :model-value="themeStore.isDarkMode"
              label="Dark Mode"
              @change="themeStore.toggleTheme"
            ></v-switch>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-btn
            variant="text"
            class="text-left px-4"
            @click="showPairingModal = true"
          >
            <v-icon start>mdi-link</v-icon>
            ペアリング
          </v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn
            variant="text"
            class="text-left px-4"
            href="/docs/"
            target="_blank"
            rel="noopener"
          >
            <v-icon start>mdi-help-circle-outline</v-icon>
            ヘルプ・ドキュメント
          </v-btn>
        </v-list-item>
        <v-list-item v-if="linkStore.isLinking">
          <v-btn variant="text" class="text-left px-4" @click="goToAnchor">
            <v-icon start>mdi-crosshairs-gps</v-icon>
            位置合わせ
          </v-btn>
        </v-list-item>
        <!-- ✅ アカウント詳細 -->
        <v-list-item v-if="!isGuest">
          <v-btn
            variant="text"
            @click="goToAccountDetail"
            class="rounded-lg"
            v-ripple
          >
            <v-icon start>mdi-account-details</v-icon>
            アカウント詳細
          </v-btn>
        </v-list-item>
        <!-- ✅ ダウンロード / アップロード（管理者は「アップロード」表記） -->
        <v-list-item v-if="!isGuest">
          <v-btn
            variant="text"
            @click="goToDownloads"
            class="rounded-lg"
            v-ripple
          >
            <v-icon start>{{ isAdmin ? 'mdi-upload' : 'mdi-download' }}</v-icon>
            {{ isAdmin ? 'アップロード' : 'ダウンロード' }}
          </v-btn>
        </v-list-item>
        <!-- ✅ オペレーション画面を編集（権限があるユーザーのみ表示） -->
        <v-list-item v-if="authStore.userSettings.can_access_operation">
          <v-btn
            variant="text"
            class="text-left px-4"
            to="/app/operation/edit"
          >
            <v-icon start>mdi-cog</v-icon>
            オペレーション画面を編集
          </v-btn>
        </v-list-item>

        <!-- ✅ モバイル用ナビゲーションリンク（NavigationDrawerの代わり） -->
        <template v-if="themeStore.isMobile && !isGuest">
          <v-divider class="my-2" />
          <v-list-item>
            <v-btn variant="text" class="text-left px-4" to="/app/rooms">
              <v-icon start>mdi-folder</v-icon>
              ルーム
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn variant="text" class="text-left px-4" to="/app/manual">
              <v-icon start>mdi-book-open-variant</v-icon>
              作業マニュアル
            </v-btn>
          </v-list-item>
          <v-list-item v-if="authStore.canAccessAnyGeneration">
            <v-btn variant="text" class="text-left px-4" to="/app/generate">
              <v-icon start>mdi-creation</v-icon>
              AI 生成
            </v-btn>
          </v-list-item>
          <!-- ✅ AI NPC（権限があるユーザーのみ表示。サイドバーと同じゲート） -->
          <v-list-item v-if="authStore.userSettings.can_access_ai_npc">
            <v-btn variant="text" class="text-left px-4" to="/app/ai-npc">
              <v-icon start>mdi-robot-happy-outline</v-icon>
              AI NPC
            </v-btn>
          </v-list-item>
          <!-- ✅ DIG 防災マップ（権限があるユーザーのみ表示。サイドバーと同じゲート） -->
          <v-list-item v-if="authStore.userSettings.can_access_dig">
            <v-btn variant="text" class="text-left px-4" to="/app/dig">
              <v-icon start>mdi-map-marker-alert</v-icon>
              防災マップ (DIG)
            </v-btn>
          </v-list-item>
          <!-- ✅ Spaces（物理スペース + Garden 管理・権限があるユーザーのみ表示。サイドバーと同じゲート） -->
          <v-list-item v-if="authStore.userSettings.can_access_spaces">
            <v-btn variant="text" class="text-left px-4" to="/app/spaces">
              <v-icon start>mdi-floor-plan</v-icon>
              スペース
            </v-btn>
          </v-list-item>
          <!-- ✅ Okaki（絵を動かす・権限があるユーザーのみ表示。サイドバーと同じゲート） -->
          <v-list-item v-if="authStore.userSettings.can_access_okaki">
            <v-btn variant="text" class="text-left px-4" to="/app/okaki">
              <v-icon start>mdi-draw</v-icon>
              Okaki（絵を動かす）
            </v-btn>
          </v-list-item>
          <!-- ✅ 業務管理（bizhub・権限があるユーザーのみ表示。サイドバーと同じゲート） -->
          <v-list-item v-if="authStore.userSettings.can_access_bizhub">
            <v-btn variant="text" class="text-left px-4" to="/app/bizhub">
              <v-icon start>mdi-briefcase-outline</v-icon>
              業務管理
            </v-btn>
          </v-list-item>
          <!-- ✅ スライド動画（権限があるユーザーのみ表示。サイドバーと同じゲート） -->
          <v-list-item v-if="authStore.userSettings.can_access_slide_video">
            <v-btn variant="text" class="text-left px-4" to="/app/slide-videos">
              <v-icon start>mdi-filmstrip-box-multiple</v-icon>
              スライド動画
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn variant="text" class="text-left px-4" to="/app/operation">
              <v-icon start>mdi-television-play</v-icon>
              オペレーション画面
            </v-btn>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>

  <!-- ✅ 削除確認モーダル -->
  <ConfirmDeleteModal
    v-model="showDeleteModal"
    title="アカウントを削除しますか？"
    message="すべてのファイル・ルームが削除されます。この操作は元に戻せません。"
    @confirm="handleDeleteAccount"
  />
  <PairingModal v-model="showPairingModal" />
  <LoginModal v-model="showLoginModal" @login-success="onLoginSuccess" />
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { auth } from "@/firebase"; // Firebase の設定ファイルをインポート
import { useThemeStore } from "@/stores/themeStore";
import { useAuthStore } from "@/stores/authStore";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import LoginModal from "@/components/LoginModal.vue";
import EditDisplayNameModal from "@/components/EditDisplayNameModal.vue";
import PairingModal from "@/components/PairingModal.vue";
import { useRoomStore } from "@/stores/roomStore";
import { useLinkStore } from "@/stores/linkStore";

const userName = ref("");
const router = useRouter();
const themeStore = useThemeStore();
const authStore = useAuthStore();
const roomStore = useRoomStore();
const linkStore = useLinkStore();
const showDeleteModal = ref(false);

const isGuest = computed(() => authStore.isGuest);
const isAdmin = computed(() => authStore.userSettings?.is_admin);

// ユーザー種別によるロゴ切り替え
const isTaitockUser = computed(() => authStore.userSettings.user_type === 'taitockeye');
const isQumowillUser = computed(() => authStore.userSettings.user_type === 'qumowill');
const taitockLogoSrc = new URL("@/assets/TaiTock_Eye_logo_L.png", import.meta.url).href;
const qumowillLogoSrc = new URL("@/assets/qumowill-ai_logo_header.png", import.meta.url).href;

// AppBarを非表示にするかどうか
const shouldHideAppBar = computed(() => {
  // hideMenuBarが有効な場合は常に非表示
  if (themeStore.hideMenuBar) return true;
  // モバイル時に特定ページで非表示
  return themeStore.isMobile && router.currentRoute.value.meta?.hideAppBarOnMobile;
});

// AppBarのスタイル（モバイル時はscroll-behaviorを有効にするためfixedを外す）
const appBarStyle = computed(() => {
  const bgColor = themeStore.isDarkMode ? 'background: black;' : isQumowillUser.value ? 'background: #0d6fa8;' : 'background: green;';
  if (themeStore.isMobile) {
    return bgColor;
  }
  return `${bgColor} position: fixed; top: 0; z-index: 1100;`;
});
const showLoginModal = ref(false);
const displayName = computed(() => authStore.user?.displayName || "");
const fallbackName = computed(() => {
  const email = authStore.user?.email || "";
  return email.split("@")[0];
});
const shownName = computed(() => displayName.value || fallbackName.value);

const showEditNameModal = ref(false);
const showPairingModal = ref(false);

const goToAnchor = () => {
  router.push({
    path: "/anchor",
    state: { returnTo: router.currentRoute.value.fullPath },
  });
};

watch(showLoginModal, (val) => {
  console.log("ログインモーダル表示状態:", val);
});

const openModal = () => {
  authStore.openLoginModal();
};

// ログアウト処理
const logout = async () => {
  try {
    const logoutPath = authStore.landingPath;
    await signOut(auth);
    // linkStore.stopPolling();
    // roomStore.closeRoomDetail();
    router.push(logoutPath); // ランディングページにリダイレクト
  } catch (error) {
    console.error("ログアウト失敗:", error);
  }
};

const handleDeleteAccount = async () => {
  showDeleteModal.value = false;
  try {
    await authStore.deleteAccount();
    router.push("/"); // トップへリダイレクト
  } catch (err) {
    console.error("削除に失敗しました", err);
    // 必要であればエラートーストなど
  }
};

const onLoginSuccess = async () => {
  console.log("✅ AppBar: ログイン成功イベント受信");
  roomStore.loadRooms();
  // linkStore.startPolling();
};

const goToOperation = () => {
  const returnTo = router.currentRoute.value.fullPath;
  router.push({
    path: "/operation",
    query: { returnTo },
  });
};

const goToAccountDetail = () => {
  router.push("/app/account");
};

const goToDownloads = () => {
  router.push("/app/downloads");
};

let initialized = false;
let justReturnedFromOperation = true;

watch(
  () => linkStore.isUserLinking,
  (newVal) => {
    if (!initialized) {
      initialized = true;
      return;
    }
    if (justReturnedFromOperation) {
      console.log("⏸️ 一時的に遷移抑制中");
      return;
    }
    if (newVal && router.currentRoute.value.path !== "/operation") {
      // goToOperation(); //オペレーションページへの自動遷移は中止する
    }
  }
);

router.afterEach((to, from) => {
  if (from.path === "/operation" && to.path === "/app/rooms") {
    console.log("🟢 OperationView → RoomList に戻ったと検知");
    justReturnedFromOperation = true;
    setTimeout(() => {
      justReturnedFromOperation = false;
    }, 2000); // 必要に応じて調整
  }
});

// ユーザー情報を取得
onMounted(() => {
  // `returnTo` に `/app/rooms` が入っていたら直前が OperationView と判断
  const fromOperation = router.currentRoute.value.query.returnTo === "/app/rooms";
  if (fromOperation) {
    justReturnedFromOperation = true;
  }
  if (justReturnedFromOperation) {
    setTimeout(() => {
      justReturnedFromOperation = false; // 数秒後に通常状態に戻す
    }, 2000); // 必要に応じて調整
  }

  // // ② ポーリング開始
  // const linkStore = useLinkStore();
  // linkStore.startPolling();

  console.log("isGuest = ", isGuest.value);
  // theme.global.name.value = "dark";
  onAuthStateChanged(auth, (user) => {
    if (user) {
      userName.value = user.email || "ユーザー"; // Firebase の表示名
      console.log("isGuest = ", isGuest.value);
    } else {
      userName.value = "";
    }
  });
});

// onUnmounted(() => {
//   const linkStore = useLinkStore();
//   linkStore.stopPolling(); // ✅ ページ離脱時に停止
// });
</script>

<style scoped>
.dark-gradient {
  background: linear-gradient(to bottom, #000000, #333333) !important;
}
.light-gradient {
  background: linear-gradient(to bottom, hwb(122 51% 0%), #81c784) !important;
}
.qumowill-gradient {
  background: linear-gradient(to bottom, #0d6fa8, #4fc3f7) !important;
}
.no-shadow {
  box-shadow: none !important;
}
.light-text {
  color: white !important;
  font-weight: bold !important;
}
.dark-text {
  color: white !important;
  font-weight: bold !important;
}
.logo {
  height: 40px;
  max-height: 40px;
  max-width: 120px;
  margin-left: 0;
  object-fit: contain;
}
.logo-taitock {
  height: 60px;
  max-height: 60px;
  max-width: 180px;
}
.user-name {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.user-name:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

/* .v-app-bar {
  position: fixed !important;
  top: 0 !important;
  z-index: 9999 !important;
} */
</style>
